import React from "react";
import { _O } from ".";
import { phonecfgInProps, SocketCommand, socketManager } from "../../components/AppProvider";
import { PostApi501 } from "../network/padoPost";

export const NativeAction = (phonecfg, actionType, actionData) => {
    if(phonecfg.phoneOS === 'ANDROID' && parseInt(phonecfg.version.split(".")[2]) >= 9) {
        const putJsonData = () => {
            return {"actionType":actionType, "actionData":actionData}
        };
        socketManager(SocketCommand.NATIVE_ACTION, undefined, putJsonData());
    } else if(phonecfg.phoneOS === 'IOS') {
        const putJsonData = () => {
            return {"actionType":actionType, "actionData":actionData}
        };
    
        socketManager(SocketCommand.NATIVE_ACTION, undefined, putJsonData());
    }   
}

export const MdEducoConnect = (
  userinfo,
  phonecfg,
  cfg,
  param,
  cnt,
  trsmId,
  reloadList
) => {
  let reset = cnt;

  updateDownYn(userinfo, cfg, trsmId);

  const putJsonData = () => {
    return {
      moveUrl:
        "http://m.mdeduco.com//court_class/login_proc.php?params=" +
        encodeURIComponent(param),
    };
  };

  if (phonecfg.phonOS === "IOS") {
    if (parseInt(phonecfg.version.split(".")[2]) >= 3) {
      socketManager(SocketCommand.MD_EDUCO_CONNECT, reloadList, putJsonData());
    } else {
      alert("앱 버전을 확인하세요.");
    }
  } else {
    socketManager(SocketCommand.MD_EDUCO_CONNECT, reloadList, putJsonData());
  }
};

export const ZoomConnect = (
  orderKey,
  signature,
  object,
  userinfo,
  hsptCode
) => {
  // updateDownYn(userinfo, cfg, trsmId);

  const putJsonData = () => {
    const moveUrl =
      "https://nftf.mdpeople.co.kr:3333/app/" +
      hsptCode +
      "?orderKey=" +
      orderKey +
      "&signature=" +
      signature +
      "&identify=0&name=" +
      encodeURIComponent(userinfo.userName);
    console.log(moveUrl);
    return {
      moveUrl: moveUrl,
    };
  };

  socketManager(SocketCommand.MD_EDUCO_CONNECT, "", putJsonData());
};

const updateDownYn = (userinfo, cfg, trsmId) => {
    PostApi501(userinfo, cfg, trsmId)
    .then(res => {
        if (res.resultMsg === 'SUCCESS') {
            // setList(res.resultList);
        }
    })
    .catch(err => {
        console.log(err);
    });
}